import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane, Table, UncontrolledDropdown } from 'reactstrap';
import KPIlist from '../../../Residue/Dashboard/Widgets/KPIlist.js';
import BiomassInfo from '../Widgets/BiomassInfo.jsx';
import MortalityInfo from '../Widgets/MortalityInfo.jsx';
import MortalityTypeInfo from '../Widgets/MortalityTypeInfo.jsx';

const ProductionSection = () => {


    const tileBoxes4 = [
        {
            id: 2,
            icon: "ri-play-circle-fill",
            iconClass: "warning",
            opacity: "bg-opacity-25",
            label: "En operación",
            labelClass: "muted",
            counter: "45",
            caption: "",
            captionClass: "muted",
            percentage: "10.35 %",
            percentageClass: "danger",
            badge: "ri-arrow-down-s-line",
            decimals: 0,
            separator: ",",
            suffix: "",
            prefix: "",
        },
        {
            id: 3,
            icon: "bx bxs-badge-dollar",
            iconClass: "danger",
            opacity: "bg-opacity-25",
            label: "Total Revenue",
            labelClass: "muted",
            counter: "2845.05",
            caption: "From $1,750.04 last year",
            captionClass: "muted",
            percentage: "22.96 %",
            percentageClass: "success",
            badge: "ri-arrow-up-s-line",
            decimals: 2,
            separator: ",",
            suffix: "",
            prefix: "$",
        },
        {
            id: 3,
            icon: "bx bxs-badge-dollar",
            iconClass: "danger",
            opacity: "bg-opacity-25",
            label: "Total Revenue",
            labelClass: "muted",
            counter: "2845.05",
            caption: "From $1,750.04 last year",
            captionClass: "muted",
            percentage: "22.96 %",
            percentageClass: "success",
            badge: "ri-arrow-up-s-line",
            decimals: 2,
            separator: ",",
            suffix: "",
            prefix: "$",
        },
    ];

    const currencies = [
        {
            id: 1,
            coinName: "Bitcoin",
            price: "48,568.025",
            iconClass: "success",
            icon: "mdi mdi-trending-up",
            change: "5.26",
            balance: "53,914.025",
            totalCoin: "1.25634801",
        },
        {
            id: 2,
            coinName: "Litecoin",
            price: "87,142.027",
            iconClass: "danger",
            icon: "mdi mdi-trending-down",
            change: "3.07",
            balance: "75,854.127",
            totalCoin: "2.85472161",
        },
        {
            id: 3,
            coinName: "Ethereum",
            price: "33,847.961",
            iconClass: "success",
            icon: "mdi mdi-trending-up",
            change: "7.13",
            balance: "44,152.185",
            totalCoin: "1.45612347",
        },
        {
            id: 4,
            coinName: "Binance",
            price: "73,654.421",
            iconClass: "success",
            icon: "mdi mdi-trending-up",
            change: "0.97",
            balance: "48,367.125",
            totalCoin: "0.35734601",
        },
        {
            id: 5,
            coinName: "Tether",
            price: "66,742.077",
            iconClass: "danger",
            icon: "mdi mdi-trending-down",
            change: "1.08",
            balance: "53,487.083",
            totalCoin: "3.62912570",
        },
        {
            id: 6,
            coinName: "Dash",
            price: "34,736.209",
            iconClass: "success",
            icon: "mdi mdi-trending-up",
            change: "4.52",
            balance: "15,203.347",
            totalCoin: "1.85412740",
        },
        {
            id: 7,
            coinName: "Neo",
            price: "56,357.313",
            iconClass: "danger",
            icon: "mdi mdi-trending-down",
            change: "2.87",
            balance: "61,843.173",
            totalCoin: "1.87732061",
        },
        {
            id: 8,
            coinName: "Dogecoin",
            price: "62,357.649",
            iconClass: "success",
            icon: "mdi mdi-trending-up",
            change: "3.45",
            balance: "54,843.173",
            totalCoin: "0.95632087",
        },
    ];



    return (
        <React.Fragment>
            <Row>
                <Col md={12}>
                    <KPIlist id={'662988cb349f7afd12930fa6'} um='t' />
                </Col>
                <Col md={12}>
                    <Row>
                        <Col md={4}>
                            <BiomassInfo title={'Biomasa'} />
                        </Col>
                        <Col md={4}>
                            <MortalityInfo  title={'Mortalidad Diaria'}/>
                        </Col>
                        <Col md={4}>
                            <MortalityTypeInfo title={'Mortalidad'}/>
                        </Col>
                    </Row>

                    {/* <Row>
                        <Col md={6}>
                            <Card>
                                <CardHeader>
                                    <h4 className="card-title mb-0">Basic Column Chart</h4>
                                </CardHeader>
                                <CardBody>
                                    <BasicColumn dataColors='["--vz-danger", "--vz-primary", "--vz-success"]' />
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card>
                                <CardHeader>
                                    <h4 className="card-title mb-0">Basic Column Chart</h4>
                                </CardHeader>
                                <CardBody>
                                    <BasicColumn dataColors='["--vz-danger", "--vz-primary", "--vz-success"]' />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>

                            <Card className="card-height-100">
                                <CardHeader className="align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">My Currencies</h4>
                                    <div className="flex-shrink-0">
                                        <button className="btn btn-soft-primary btn-sm">24H</button>
                                    </div>
                                    <div className="flex-shrink-0 ms-2">
                                        <UncontrolledDropdown className="card-header-dropdown" direction='start'>
                                            <DropdownToggle className="btn btn-soft-primary btn-sm" role="button" tag="a">
                                                Get Report<i className="mdi mdi-chevron-down align-middle ms-1"></i>
                                            </DropdownToggle>
                                            <DropdownMenu className="dropdown-menu dropdown-menu-end">
                                                <DropdownItem>Download Report</DropdownItem>
                                                <DropdownItem>Export</DropdownItem>
                                                <DropdownItem>Import</DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>
                                </CardHeader>
                                <div className="card-body">
                                    <div className="table-responsive table-card">
                                        <table className="table table-hover table-borderless table-centered align-middle table-nowrap mb-0">
                                            <thead className="text-muted bg-light-subtle">
                                                <tr>
                                                    <th>Coin Name</th>
                                                    <th>Price</th>
                                                    <th>24h Change</th>
                                                    <th>Total Balance</th>
                                                    <th>Total Coin</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(currencies || []).map((item, key) => (
                                                    <tr key={key}>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <div>
                                                                    <h6 className="mb-0">{item.coinName}</h6>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>${item.price}</td>
                                                        <td><h6 className={"mb-0 text-" + item.iconClass}><i className={"align-middle me-1 " + item.icon}></i>{item.change}</h6></td>
                                                        <td>${item.balance}</td>
                                                        <td>{item.totalCoin}</td>
                                                        <td>Trade</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col md={6}>

                            <Card className="card-height-100">
                                <CardHeader className="align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">My Currencies</h4>
                                    <div className="flex-shrink-0">
                                        <button className="btn btn-soft-primary btn-sm">24H</button>
                                    </div>
                                    <div className="flex-shrink-0 ms-2">
                                        <UncontrolledDropdown className="card-header-dropdown" direction='start'>
                                            <DropdownToggle className="btn btn-soft-primary btn-sm" role="button" tag="a">
                                                Get Report<i className="mdi mdi-chevron-down align-middle ms-1"></i>
                                            </DropdownToggle>
                                            <DropdownMenu className="dropdown-menu dropdown-menu-end">
                                                <DropdownItem>Download Report</DropdownItem>
                                                <DropdownItem>Export</DropdownItem>
                                                <DropdownItem>Import</DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>
                                </CardHeader>
                                <div className="card-body">
                                    <div className="table-responsive table-card">
                                        <table className="table table-hover table-borderless table-centered align-middle table-nowrap mb-0">
                                            <thead className="text-muted bg-light-subtle">
                                                <tr>
                                                    <th>Coin Name</th>
                                                    <th>Price</th>
                                                    <th>24h Change</th>
                                                    <th>Total Balance</th>
                                                    <th>Total Coin</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(currencies || []).map((item, key) => (
                                                    <tr key={key}>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <div>
                                                                    <h6 className="mb-0">{item.coinName}</h6>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>${item.price}</td>
                                                        <td><h6 className={"mb-0 text-" + item.iconClass}><i className={"align-middle me-1 " + item.icon}></i>{item.change}</h6></td>
                                                        <td>${item.balance}</td>
                                                        <td>{item.totalCoin}</td>
                                                        <td>Trade</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row> */}
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default ProductionSection;